import { IStatusPanelParams } from "ag-grid-enterprise";
import { forwardRef, useImperativeHandle, useState } from "react";

type IType = "SIMPLE" | "WITH_TOTAL";
export interface IStatusBarForServerSide {
    setTotal: React.Dispatch<React.SetStateAction<number | null>>;
    total: number;
    setTotal2: React.Dispatch<React.SetStateAction<number | null>>;
    total2: number;
    setType: React.Dispatch<React.SetStateAction<IType | null>>;
    type: IType;
    setLabel: React.Dispatch<React.SetStateAction<string>>;
    label: string;
}

export default forwardRef((props: IStatusPanelParams, ref) => {
    const [total, setTotal] = useState<number | null>(0);
    const [total2, setTotal2] = useState<number | null>(0);
    const [type, setType] = useState<IType>("SIMPLE");
    const [label, setLabel] = useState("total");
    useImperativeHandle(ref, () => {
        return {
            setTotal: (value: number) => {
                setTotal(value);
            },
            total: () => {
                return total;
            },

            setTotal2: (value: number) => {
                setTotal2(value);
            },
            total2: () => {
                return total2;
            },

            setType: (value: IType) => {
                setType(value);
            },

            type: () => {
                return type;
            },

            setLabel: (str: string) => {
                setLabel(str);
            },
            label: () => {
                return label;
            },
        };
    });
    return (
        <div className="d-flex w-100 gap-3">
            {
                {
                    SIMPLE: (
                        <span>
                            {label}: <span style={{ color: "black" }}>{total}</span>
                        </span>
                    ),
                    WITH_TOTAL: (
                        <span>
                            Rows:{" "}
                            <span style={{ color: "black" }}>
                                {total} of {total2}
                            </span>
                        </span>
                    ),
                }[type]
            }
        </div>
    );
});
